import { render, staticRenderFns } from "./rebrandingInfo.vue?vue&type=template&id=1221a637&scoped=true"
import script from "./rebrandingInfo.vue?vue&type=script&lang=js"
export * from "./rebrandingInfo.vue?vue&type=script&lang=js"
import style0 from "./rebrandingInfo.vue?vue&type=style&index=0&id=1221a637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221a637",
  null
  
)

export default component.exports